import ContentSharings from './components/ContentSharings'
import ContentSharingsSaga from './sagas'

export default ContentSharings
export { ContentSharingsSaga }
